module.exports = __webpack_public_path__ + "img/9.0aab72c0.png";